import { render } from "./PaginationItem.vue?vue&type=template&id=4e8439c0&bindings={}"
import script from "./PaginationItem.vue?vue&type=script&lang=ts"
export * from "./PaginationItem.vue?vue&type=script&lang=ts"

import "./PaginationItem.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script